var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCustomer = function SvgLogoBrandCustomer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "60px",
    viewBox: "0 0 200 60",
    style: {
      enableBackground: "new 0 0 200 60"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003869;}\r\n\t.st1{fill:#00A8E1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kielumweltpreis2022-kundenlogo-rgb",
    transform: "translate(32.561 -9.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11493",
    className: "st0",
    d: "M-26,34.8l3.4-0.2c0.2,1.1,0.4,2.5,1.7,2.5c1,0,1.4-0.9,1.4-1.8c0-1-0.6-1.8-1.8-2.8 l-1.8-1.8c-1.7-1.6-2.7-3.1-2.7-5.2c0-2.6,1.6-4.8,5-4.8c2.3,0,4.6,1.2,4.7,5.4l-3.3,0.2c-0.2-1.4-0.4-2.5-1.6-2.5 c-1,0-1.3,0.7-1.3,1.6c0,1,1,1.9,1.9,2.8l1.6,1.6c1.8,1.8,2.8,3.4,2.8,5.5c0.1,2.6-1.9,4.8-4.5,5c0,0,0,0,0,0h-0.5 C-24,40.2-25.9,38.1-26,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11494",
    className: "st0",
    d: "M-11.3,24.2h-3.6v-3.1H-4v3.1h-3.5v15.7h-3.8V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11495",
    className: "st0",
    d: "M-1,21.1h5.1L7.9,40H4.1l-0.8-4.2h-3.9L-1.3,40h-3.4L-1,21.1z M2.7,32.7l-1.3-7.5H1.3 L0,32.7H2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11496",
    className: "st0",
    d: "M8.7,21.1h5.5c2.9,0,5.1,1.4,5.1,4.6v9.5c0,3.3-2.2,4.8-5.1,4.8H8.7V21.1z M13.8,36.7 c0.9,0,1.6-0.6,1.7-1.5V26c0.1-0.8-0.5-1.6-1.4-1.7c0,0,0,0,0,0h-1.6v12.4H13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11497",
    className: "st0",
    d: "M23.9,24.2h-3.6v-3.1h10.9v3.1h-3.5v15.7h-3.8V24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11498",
    className: "st0",
    d: "M31.8,21.1h3.7L37,32.3H37L38.7,21h3.6l1.6,11.2h0.1L45.5,21h3.3l-3,18.9h-3.4l-1.8-12 h-0.2l-1.9,12h-3.5L31.8,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11499",
    className: "st0",
    d: "M50.5,21.1h9.1v3.1h-5.4v4.5h4.2v3.1h-4.2v4.9h5.5v3.2h-9.1V21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11500",
    className: "st0",
    d: "M62,21.1h5.5c3.1,0,5.1,1.8,5.1,5.6c0,2.7-0.9,4.2-2.2,5l2.5,8.3H69l-1.9-7.5h-1.3V40h-3.7 V21.1H62z M67.1,29.7c1,0,1.7-0.7,1.7-2.8c0-1.8-0.6-2.7-1.7-2.7h-1.3v5.5L67.1,29.7L67.1,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11501",
    className: "st0",
    d: "M75,21.1h3.7v8.3l3.7-8.3H86l-3.4,7.4L86,39.9h-3.9l-2.2-8.3l-1.3,2.2v6.2H75L75,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11502",
    className: "st0",
    d: "M88.1,21.1h9.1v3.1h-5.4v4.5h4.2v3.1h-4.2v4.9h5.5v3.2h-9.1V21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11503",
    className: "st0",
    d: "M103.9,21.1h1.8v9.5l5-9.5h1.8l-3.7,7.2l3.8,11.7h-1.9l-3.2-9.9l-1.8,3.2v6.7h-1.8 L103.9,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11504",
    className: "st0",
    d: "M115.3,21.1h1.8V40h-1.8V21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11505",
    className: "st0",
    d: "M120.6,21.1h7.1v1.4h-5.3v6.7h4.2v1.6h-4.2v7.5h5.3v1.6h-7.1L120.6,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11506",
    className: "st0",
    d: "M130,21.1h1.8v17.3h5.3V40h-7.1L130,21.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11507",
    className: "st0",
    d: "M157.6,12.9l-0.5,2h2.9l-3.4,13.2h2.2l3.9-15.2H157.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11508",
    className: "st1",
    d: "M156.7,9.4L153,24.4v-4h-1.9v1.4h-1.1l2.2-9h-1.4l0.9-3.5h-0.6L146.8,26h-2.9l1.8-6.9 c0.4-1.7,0.5-2,0.7-3.3c0.4-1.3-0.4-2.7-1.7-3c0,0,0,0,0,0c-0.3-0.1-0.5-0.1-0.8-0.1c-1.4-0.1-2.7,0.9-2.9,2.3c0,0.1,0,0.2,0,0.2 v1.2h2.2v-1.1c0-0.3,0.2-0.6,0.6-0.6c0.3,0,0.5,0.2,0.5,0.7c-0.1,0.8-0.2,1.5-0.4,2.2L141.1,28h5.1l-0.9,3.5h0.6l1.9-7.8h3V28h1 l-0.9,3.5h1.8l5.5-22.1H156.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11509",
    className: "st1",
    d: "M-25.3,59.8h5.2v1.4h-3.6v1.7h3v1.4h-3v3h-1.6V59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11510",
    className: "st1",
    d: "M-19.5,61.8h1.4v0.9l0,0c0.4-0.6,1-0.9,1.7-1h0.5v1.4c-0.2,0-0.4-0.1-0.6-0.1 c-0.8,0-1.6,0.4-1.6,1.4v2.8h-1.4V61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11511",
    className: "st1",
    d: "M-15.1,59.6h1.5v1.4h-1.5V59.6z M-15.1,61.8h1.5v5.4h-1.5V61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11512",
    className: "st1",
    d: "M-12.6,66.4l0.9-0.9c0.4,0.4,0.9,0.7,1.5,0.6c0.5,0,1-0.2,1-0.6c0-0.4-0.2-0.5-0.9-0.6 c-0.3,0-0.5-0.1-0.8-0.2c-0.9-0.2-1.4-0.6-1.4-1.4c0-1.1,1-1.8,2.2-1.8c0.8-0.1,1.6,0.2,2.2,0.8l-1,0.8 c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.8,0.2-0.8,0.5c0,0.3,0.4,0.4,0.9,0.5l0.9,0.2c0.8,0,1.5,0.7,1.4,1.5c0,1.3-1.4,1.8-2.4,1.8 C-11,67.4-12,67.1-12.6,66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11513",
    className: "st1",
    d: "M-7,65.2v-1c0-1.3,1-2.4,2.3-2.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3,0.8,2.4,2c0,0,0,0.1,0,0.1 V64h-1.4v-0.2c0-0.5-0.4-0.9-0.8-0.9c0,0-0.1,0-0.1,0c-0.5-0.1-1,0.3-1,0.8c0,0,0,0.1,0,0.1v1.3c0,0.6,0.4,1,1,1 c0.5,0.1,0.9-0.3,1-0.8c0,0,0-0.1,0-0.1v-0.1H-2v0.2c-0.1,1.2-1.1,2.1-2.3,2c-0.1,0-0.1,0-0.2,0c-1.3,0.1-2.4-0.8-2.6-2 C-7,65.3-7,65.2-7,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11514",
    className: "st1",
    d: "M-1.1,59.8h1.5v2.7l0,0c0.3-0.5,0.9-0.8,1.5-0.8c0.9-0.1,1.8,0.6,1.9,1.6 c0,0.1,0,0.2,0,0.4v3.6H2.3v-3.1c0-0.6-0.3-1.1-0.9-1.1c-0.6,0-1,0.4-1,1.2v3h-1.5V59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11515",
    className: "st1",
    d: "M4.8,65.2v-1c0-1.3,1-2.4,2.3-2.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3,0.8,2.4,2 c0,0.1,0,0.1,0,0.2v1H6.4v0.2c0,0.6,0.6,1,1.2,1c0.5,0,1-0.2,1.3-0.6l0.8,0.8c-0.5,0.7-1.4,1.1-2.2,1C6,67.3,4.8,66.7,4.8,65.2z  M8.3,64v-0.2c0-0.5-0.4-1-1-1s-1,0.4-1,1v0.1L8.3,64L8.3,64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11516",
    className: "st1",
    d: "M13.3,59.8h5.3v1.4h-3.7v1.6h3.2v1.4h-3.2v1.7h3.8v1.4h-5.4V59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11517",
    className: "st1",
    d: "M19.8,61.8h1.4v0.6l0,0c0.4-0.5,1-0.8,1.6-0.8c0.9-0.1,1.8,0.6,1.9,1.6c0,0.1,0,0.2,0,0.4 v3.6h-1.5v-3.1c0-0.6-0.3-1.1-0.9-1.1c-0.6,0-1,0.4-1,1.2v3h-1.5V61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11518",
    className: "st1",
    d: "M25.7,65.2v-1c0-1.3,1-2.4,2.3-2.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3,0.8,2.4,2 c0,0.1,0,0.1,0,0.2v1h-3.4v0.2c0,0.6,0.6,1,1.2,1c0.5,0,1-0.2,1.3-0.6l0.8,0.8c-0.5,0.7-1.4,1.1-2.2,1 C26.9,67.3,25.7,66.7,25.7,65.2z M29.2,64v-0.2c0-0.5-0.4-1-1-1s-1,0.4-1,1v0.1L29.2,64L29.2,64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11519",
    className: "st1",
    d: "M31.7,61.8h1.4v0.9l0,0c0.4-0.6,1-0.9,1.7-1h0.5v1.4c-0.2,0-0.4-0.1-0.6-0.1 c-0.8,0-1.6,0.4-1.6,1.4v2.8h-1.5v-5.4H31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11520",
    className: "st1",
    d: "M36,68.2l1-0.7c0.3,0.4,0.8,0.6,1.3,0.6c0.6,0,1.1-0.4,1.1-1c0-0.1,0-0.1,0-0.2v-0.6l0,0 c-0.3,0.5-0.9,0.7-1.4,0.7c-1,0.1-2-0.6-2.1-1.7c0-0.1,0-0.3,0-0.4v-1.1c-0.1-1.1,0.8-2.1,1.9-2.2c0.1,0,0.1,0,0.2,0 c0.6,0,1.1,0.3,1.4,0.7l0,0v-0.6h1.4v4.9c0.1,1.3-0.9,2.5-2.3,2.6c-0.1,0-0.3,0-0.4,0C37.4,69.3,36.5,68.9,36,68.2z M39.5,64.9 v-1.1c0-0.5-0.4-1-0.9-1c0,0-0.1,0-0.1,0c-0.5,0-0.9,0.3-1,0.8c0,0.1,0,0.1,0,0.2V65c0,0.5,0.4,1,0.9,1c0,0,0.1,0,0.1,0 C39,65.9,39.4,65.5,39.5,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11521",
    className: "st1",
    d: "M42.2,59.6h1.5v1.4h-1.5V59.6z M42.2,61.8h1.5v5.4h-1.5V61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11522",
    className: "st1",
    d: "M44.7,65.2v-1c0-1.3,1-2.4,2.3-2.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3,0.8,2.4,2 c0,0.1,0,0.1,0,0.2v1h-3.4v0.2c0,0.6,0.6,1,1.2,1c0.5,0,1-0.2,1.3-0.6l0.8,0.8c-0.5,0.7-1.4,1.1-2.2,1 C45.9,67.3,44.7,66.7,44.7,65.2z M48.2,64v-0.2c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v0.1L48.2,64L48.2,64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11523",
    className: "st1",
    d: "M53.5,62.9h-0.7v-1.1h0.7v-0.6c-0.1-0.8,0.5-1.5,1.3-1.6c0.1,0,0.2,0,0.3,0 c0.3,0,0.5,0,0.8,0.1v1.1c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0.1-0.4,0.4v0.6h1v1.1h-1v4.2h-1.4L53.5,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11524",
    className: "st1",
    d: "M56.7,65.4v-3.6h1.5v3.1c0,0.6,0.3,1.1,1,1.1s1-0.4,1-1.2v-3.1h1.5v5.4h-1.4v-0.7l0,0 c-0.4,0.5-1,0.8-1.6,0.8c-0.9,0.1-1.8-0.5-1.9-1.4C56.7,65.7,56.7,65.6,56.7,65.4z M57.3,59.6h1.4v1.4h-1.4L57.3,59.6z  M59.6,59.6h1.4v1.4h-1.4L59.6,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11525",
    className: "st1",
    d: "M62.8,61.8h1.4v0.9l0,0c0.4-0.6,1-0.9,1.7-1h0.5v1.4c-0.2,0-0.4-0.1-0.6-0.1 c-0.8,0-1.6,0.4-1.6,1.4v2.8h-1.5v-5.4H62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11526",
    className: "st1",
    d: "M69.4,65.2v-1.4c-0.1-1.1,0.8-2,1.9-2.1c0.1,0,0.2,0,0.3,0c0.5,0,1,0.2,1.4,0.6l0,0v-2.6 h1.5v7.5H73v-0.6l0,0c-0.4,0.4-0.9,0.7-1.5,0.7c-1.1,0.1-2-0.7-2.1-1.8C69.4,65.5,69.4,65.4,69.4,65.2z M73,65.2v-1.3 c0-0.5-0.4-1-0.9-1c0,0-0.1,0-0.1,0c-0.5,0-0.9,0.3-1,0.8c0,0.1,0,0.1,0,0.2v1.3c0,0.5,0.4,1,0.9,1c0,0,0.1,0,0.1,0 C72.6,66.2,73,65.8,73,65.2C73,65.2,73,65.2,73,65.2L73,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11527",
    className: "st1",
    d: "M75.8,59.6h1.5v1.4h-1.5V59.6z M75.8,61.8h1.5v5.4h-1.5V61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11528",
    className: "st1",
    d: "M78.3,65.2v-1c0-1.3,1-2.4,2.3-2.4c0.1,0,0.2,0,0.3,0c1.2-0.1,2.3,0.8,2.4,2 c0,0.1,0,0.1,0,0.2v1h-3.4v0.2c0,0.6,0.6,1,1.2,1c0.5,0,1-0.2,1.3-0.6l0.8,0.8c-0.5,0.7-1.4,1.1-2.2,1 C79.6,67.3,78.3,66.7,78.3,65.2z M81.8,64v-0.2c0-0.5-0.4-1-1-1c-0.5,0-1,0.4-1,1v0.1L81.8,64L81.8,64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11529",
    className: "st1",
    d: "M86.5,66l3.5-4.9h-3.4v-1.4H92V61l-3.5,4.9H92v1.4h-5.6L86.5,66L86.5,66L86.5,66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11530",
    className: "st1",
    d: "M93.2,65.4v-3.6h1.5v3.1c0,0.6,0.3,1.1,1,1.1s1-0.4,1-1.2v-3.1h1.5v5.4h-1.4v-0.7l0,0 c-0.4,0.5-1,0.8-1.6,0.8c-0.9,0.1-1.8-0.5-1.9-1.4C93.2,65.7,93.2,65.6,93.2,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11531",
    className: "st1",
    d: "M99.3,59.8h1.5V64l1.8-2.2h1.7l-1.8,2l1.8,3.4h-1.7l-1.3-2.4l-0.6,0.7v1.7h-1.5L99.3,59.8z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11532",
    className: "st1",
    d: "M105.1,65.4v-3.6h1.5v3.1c0,0.6,0.3,1.1,1,1.1s1-0.4,1-1.2v-3.1h1.5v5.4h-1.4v-0.7l0,0 c-0.4,0.5-1,0.8-1.6,0.8c-0.9,0.1-1.8-0.5-1.9-1.4C105.1,65.7,105.1,65.6,105.1,65.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11533",
    className: "st1",
    d: "M111.2,61.8h1.4v0.6l0,0c0.4-0.5,1-0.8,1.6-0.8c0.9-0.1,1.8,0.6,1.9,1.6c0,0.1,0,0.2,0,0.4 v3.6h-1.5v-3.1c0-0.6-0.3-1.1-0.9-1.1c-0.6,0-1,0.4-1,1.2v3h-1.5L111.2,61.8L111.2,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11534",
    className: "st1",
    d: "M117.6,62.9h-0.7v-1.1h0.7v-0.6c-0.1-0.8,0.5-1.5,1.3-1.6c0.1,0,0.2,0,0.3,0 c0.3,0,0.5,0,0.8,0.1v1.1c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0-0.4,0.1-0.4,0.4v0.6h1v1.1h-1v4.2h-1.4L117.6,62.9L117.6,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11535",
    className: "st1",
    d: "M121.1,65.9V63h-0.7v-1.1h0.7v-1.6h1.5v1.6h1.1V63h-1.1v2.6c0,0.2,0.1,0.4,0.4,0.5 c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.6-0.1v1.2c-0.3,0.1-0.7,0.1-1,0.2C121.9,67.3,121.1,66.9,121.1,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11536",
    className: "st1",
    d: "M124.6,65.6h1.6v1.7h-1.6V65.6z"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCustomer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-customer.8a2b83fbf171891537f88e825f690dce.svg";